import { faBell, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HoursInput from "../../../components/ui/HoursInput";
import { useEffect, useState } from "react";
import BlockNotificationsItem from "./BlockNotificationsItem";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import logo_max from '../../../files/system/Max_color.svg';
import BlockProviderMaxAdd from "./BlockProviderMaxAdd";
import BlockProviderMaxRemove from "./BlockProviderMaxRemove";
import { updateBotMax } from '../../../reducers/models/setting'
import ErrorAdd from "../../../util/ErrorAdd";

function BlockNotifications() {

    const dispatch = useDispatch()

    const stateSetting = useSelector((state) => state.setting);//Настройки

    const [minute, setMinute] = useState(null);
    const [hour, setHour] = useState(null);
    const [weekendDay, setWeekendDay] = useState(null);
    // const [maxExist, setMaxExist] = useState(null);

    const [modalMaxShow, setModalMaxShow] = useState(false);
    const [modalMaxRemoveShow, setModalMaxRemoveShow] = useState(false);



    useEffect(() => {
        if (stateSetting.botMaxExist === null) {
            //Наличие бота MAX
            axios.get('/api_tracker/bot/maxExist')
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(updateBotMax({ data: res.data.Data }));
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }, []);

    useEffect(() => {
        if (stateSetting.userParameter.length > 0) {
            setHour(stateSetting.userParameter.filter(a => a.ID_Parameter === 8)[0].Value_Float);
            setMinute(stateSetting.userParameter.filter(a => a.ID_Parameter === 9)[0].Value_Float);
            setWeekendDay(stateSetting.userParameter.filter(a => a.ID_Parameter === 10)[0].Value_Bool);
        }
    }, [stateSetting.userParameter]);

    const [loadingTime, setLoadingTime] = useState(false);
    const [logTime, setLogTime] = useState(null);

    function timeChangeHandler(data) {
        setLogTime(null);
        setLoadingTime(true);

        setHour(data.hour);
        setMinute(data.minute);

        axios.post('/api_main/user/parameterSet', { ID_Parameter: 8, Value_Float: data.hour })
            .then((res) => {
                if (res.data.Status === 1) {
                    axios.post('/api_main/user/parameterSet', { ID_Parameter: 9, Value_Float: data.minute })
                        .then((res1) => {
                            if (res1.data.Status === 1) {
                                setLoadingTime(false);
                            }
                            else {
                                setLoadingTime(false);
                                setLogTime(res.data.Error);
                            }
                        })
                        .catch((err) => {
                            setLogTime('Неизвестная ошибка!');
                            setLoadingTime(false);
                            ErrorAdd(err, window.location.href);
                        });
                }
                else {
                    setLoadingTime(false);
                    setLogTime(res.data.Error);
                }
            })
            .catch((err) => {
                setLogTime('Неизвестная ошибка!');
                setLoadingTime(false);
                ErrorAdd(err, window.location.href);
            });


    }

    const [loadingWeekendDay, setLoadingWeekendDay] = useState(false);
    const [logWeekendDay, setLogWeekendDay] = useState(null);

    function weekendDayChangeHandler(val) {
        setLoadingWeekendDay(true);
        setLogWeekendDay(null);

        axios.post('/api_main/user/parameterSet', { ID_Parameter: 10, Value_Bool: val.target.value == 'true' ? true : false })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoadingWeekendDay(false);
                }
                else {
                    setLoadingWeekendDay(false);
                    setLogWeekendDay(res.data.Error);
                }
            })
            .catch((err) => {
                setLogWeekendDay('Неизвестная ошибка!');
                setLoadingWeekendDay(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //Закрываем модальное окно при изменении значения botMaxExist = true
    useEffect(() => {
        if (stateSetting.botMaxExist === true) {
            setModalMaxShow(false);
        }
    }, [stateSetting.botMaxExist]);


    return (
        <>
            {modalMaxShow === true && (<BlockProviderMaxAdd show={modalMaxShow} onHide={() => setModalMaxShow(false)} />)}
            {modalMaxRemoveShow === true && (<BlockProviderMaxRemove show={modalMaxRemoveShow} onHide={() => setModalMaxRemoveShow(false)} />)}

            <div className="main-card mb-3 card">
                <div className="card-header-tab card-header-tab-animation card-header">
                    <div className="card-header-title">
                        <i className="fas fa-lg mr-10"><FontAwesomeIcon icon={faBell} /></i>Уведомления
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <HoursInput label={"Время уведомлений:"} changeValue={{ hour: hour, minute: minute }} change={(res) => timeChangeHandler(res)} loading={loadingTime} />
                                    {logTime !== null && <div className="form_error text-center mt-15">{logTime}</div>}
                                </div>
                                <div className="col-md-6">
                                    <Form.Label>Выходные и праздничные дни</Form.Label>
                                    <Form.Select key={weekendDay} defaultValue={weekendDay} onChange={e => weekendDayChangeHandler(e)} disabled={loadingWeekendDay}>
                                        <option value={true}>Разрешить</option>
                                        <option value={false}>Запретить</option>
                                    </Form.Select>
                                    {logWeekendDay !== null && <div className="form_error text-center mt-15">{logWeekendDay}</div>}
                                </div>
                            </div>
                            <BlockNotificationsItem maxExist={stateSetting.botMaxExist} />
                            <div >
                                {stateSetting.botMaxExist === true ?
                                    (
                                        <div className="social_block">
                                            <a className='btn social_btn disabled_' onClick={() => setModalMaxRemoveShow(true)} >
                                                <img className="social_img" src={logo_max}></img>
                                                <i className="fas fa-lg mr-10 text-success"><FontAwesomeIcon icon={faCheck} /></i>
                                                Макс Bot (ПОДКЛЮЧЕНО)
                                            </a>
                                        </div>
                                    ) : (
                                        <div className="social_block">
                                            <a className='btn social_btn' onClick={() => setModalMaxShow(true)}>
                                                <img className="social_img" src={logo_max}></img>
                                                Подключить Макс Bot
                                            </a>
                                        </div>
                                    )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default BlockNotifications;